import Image from 'next/image'
import { useTranslation } from 'react-i18next'
import { FCC } from '~/core/@types/global'
import { TypographyText } from '~/core/ui/Text'
import SectionContainer from '../LandingPage/components/section/SectionContainer'

const PLUS = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none">
    <line y1="6.5" x2="13" y2="6.5" stroke="#9CA3AF" />
    <line x1="6.5" y1="2.18557e-08" x2="6.5" y2="13" stroke="#9CA3AF" />
  </svg>
)

const ICON_1 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none">
    <path
      d="M13 14.5V2.5C13 2.5 19.5 3.5 22 6C25.0414 9.04138 25 14.5 25 14.5H13Z"
      fill="#D4DAE0"
    />
    <path
      d="M6.5 22.5L3.5 18.5L2.5 14L3 10C3 10 2.98183 14.6524 4.5 17C6.26475 19.7289 9.10583 20.4871 11.5 21.5C15.4654 23.1777 23 21 23 21L18.5 24.5L12 25.5L6.5 22.5Z"
      fill="#D4DAE0"
    />
    <path
      d="M9.33976 3.35156L9.3258 2.60169C9.28108 2.60253 9.23653 2.60736 9.19268 2.61613L9.33976 3.35156ZM9.38664 3.38184L10.0768 3.08818L10.0734 3.08031L9.38664 3.38184ZM9.36027 3.44727L9.06027 2.75979L9.05024 2.76435L9.36027 3.44727ZM9.04191 3.5918L8.73184 2.90879L8.72104 2.9139L9.04191 3.5918ZM5.20402 6.54199L4.63143 6.05745L4.62393 6.06661L5.20402 6.54199ZM4.98234 6.8125L4.40218 6.33706L4.39527 6.34576L4.98234 6.8125ZM2.75969 11.4941L2.02682 11.3344L2.02457 11.3454L2.75969 11.4941ZM2.69035 11.8369L1.95515 11.6882L1.95302 11.6996L2.69035 11.8369ZM3.02043 17.3496L2.30463 17.5738L2.30808 17.5843L3.02043 17.3496ZM3.1298 17.6816L2.41737 17.9163L2.42127 17.9276L3.1298 17.6816ZM5.89348 22.0654L5.36611 22.5988L5.37477 22.6071L5.89348 22.0654ZM6.14641 22.3076L5.62765 22.8494L5.63568 22.8569L6.14641 22.3076ZM10.6415 24.8848L10.4255 25.6031L10.4366 25.6062L10.6415 24.8848ZM10.9784 24.9805L10.7735 25.702L10.7845 25.705L10.9784 24.9805ZM16.1581 25.1514L16.3038 25.8872L16.3153 25.8847L16.1581 25.1514ZM16.4999 25.0781L16.6571 25.8116L16.6681 25.809L16.4999 25.0781ZM21.1562 22.8027L21.6296 23.3844L21.6296 23.3844L21.1562 22.8027ZM24.4706 18.3857L25.1614 18.6779L25.1614 18.6778L24.4706 18.3857ZM24.5361 18.3594L24.8282 17.6686L24.821 17.6656L24.5361 18.3594ZM24.5634 18.4248L25.2542 18.7169L25.2547 18.7156L24.5634 18.4248ZM21.2187 22.8799L21.6921 23.4616L21.6921 23.4616L21.2187 22.8799ZM16.5224 25.1758L16.6783 25.9095L16.6905 25.9067L16.5224 25.1758ZM16.1777 25.249L16.3234 25.9848L16.3335 25.9826L16.1777 25.249ZM10.953 25.0771L10.7478 25.7986L10.7592 25.8017L10.953 25.0771ZM10.6132 24.9805L10.3972 25.6988L10.408 25.7018L10.6132 24.9805ZM6.07805 22.3809L5.5592 22.9225L5.56732 22.9301L6.07805 22.3809ZM5.82316 22.1367L5.29579 22.6701L5.30437 22.6783L5.82316 22.1367ZM3.03508 17.7148L2.32244 17.9489L2.32655 17.9608L3.03508 17.7148ZM2.92473 17.3789L2.20893 17.603L2.21218 17.613L2.92473 17.3789ZM2.59172 11.8184L1.85666 11.6689L1.85439 11.6811L2.59172 11.8184ZM2.66203 11.4727L1.92918 11.3129L1.92708 11.3232L2.66203 11.4727ZM4.90422 6.75L4.32442 6.27411L4.31714 6.28326L4.90422 6.75ZM5.12785 6.47754L4.55526 5.99301L4.54812 6.00171L5.12785 6.47754ZM9.32023 3.35547L9.17315 2.62003C9.1206 2.63054 9.06933 2.64665 9.02022 2.66809L9.32023 3.35547ZM13.9364 2.44727V1.69727V2.44727ZM18.3329 3.32129L18.6199 2.62838L18.6199 2.62838L18.3329 3.32129ZM22.0605 5.8125L22.5908 5.2822L22.5908 5.28217L22.0605 5.8125ZM24.5507 9.53906L25.2436 9.25205V9.25205L24.5507 9.53906ZM25.4247 13.9355H26.1747V13.9355L25.4247 13.9355ZM24.3808 14.9795V15.7295H24.381L24.3808 14.9795ZM12.8925 3.49121L12.1425 3.49098V3.49121H12.8925ZM13.1982 2.75293L12.668 2.22248L12.6678 2.2226L13.1982 2.75293ZM9.33976 3.35156L9.35373 4.10143C9.07375 4.10665 8.81448 3.94428 8.69992 3.68336L9.38664 3.38184L10.0734 3.08031C9.94208 2.78132 9.64494 2.59575 9.3258 2.60169L9.33976 3.35156ZM9.38664 3.38184L8.69651 3.67548C8.54288 3.3144 8.71592 2.91015 9.0603 2.75987L9.36027 3.44727L9.66024 4.13467C10.055 3.96242 10.2519 3.49969 10.0768 3.08819L9.38664 3.38184ZM9.36027 3.44727L9.05024 2.76435L8.73188 2.90888L9.04191 3.5918L9.35195 4.27472L9.67031 4.13018L9.36027 3.44727ZM9.04191 3.5918L8.72104 2.9139C7.1492 3.65792 5.75474 4.73015 4.6315 6.05751L5.20402 6.54199L5.77654 7.02647C6.76166 5.86233 7.98457 4.92206 9.36279 4.26969L9.04191 3.5918ZM5.20402 6.54199L4.62393 6.06661L4.40225 6.33712L4.98234 6.8125L5.56244 7.28788L5.78412 7.01738L5.20402 6.54199ZM4.98234 6.8125L4.39527 6.34576C3.23374 7.80676 2.42385 9.51378 2.0269 11.3344L2.75969 11.4941L3.49247 11.6539C3.84053 10.0576 4.55072 8.56058 5.56942 7.27924L4.98234 6.8125ZM2.75969 11.4941L2.02457 11.3454L1.95524 11.6882L2.69035 11.8369L3.42546 11.9856L3.4948 11.6428L2.75969 11.4941ZM2.69035 11.8369L1.95302 11.6996C1.58855 13.657 1.70978 15.674 2.3047 17.5738L3.02043 17.3496L3.73615 17.1255C3.21435 15.4593 3.10812 13.6904 3.42768 11.9742L2.69035 11.8369ZM3.02043 17.3496L2.30808 17.5843L2.41746 17.9163L3.1298 17.6816L3.84215 17.447L3.73277 17.115L3.02043 17.3496ZM3.1298 17.6816L2.42127 17.9276C3.03217 19.6876 4.0388 21.2864 5.36617 22.5988L5.89348 22.0654L6.42078 21.5321C5.25696 20.3814 4.37414 18.9794 3.83834 17.4357L3.1298 17.6816ZM5.89348 22.0654L5.37477 22.6071L5.6277 22.8493L6.14641 22.3076L6.66511 21.7659L6.41218 21.5237L5.89348 22.0654ZM6.14641 22.3076L5.63568 22.8569C6.99993 24.1254 8.63849 25.0655 10.4255 25.603L10.6415 24.8848L10.8575 24.1665C9.29032 23.6952 7.8534 22.8708 6.65713 21.7584L6.14641 22.3076ZM10.6415 24.8848L10.4366 25.6062L10.7735 25.7019L10.9784 24.9805L11.1834 24.259L10.8465 24.1633L10.6415 24.8848ZM10.9784 24.9805L10.7845 25.705C12.5844 26.1867 14.4729 26.2497 16.3038 25.8871L16.1581 25.1514L16.0124 24.4157C14.4068 24.7336 12.7506 24.6784 11.1723 24.256L10.9784 24.9805ZM16.1581 25.1514L16.3153 25.8847L16.6571 25.8115L16.4999 25.0781L16.3428 24.3448L16.001 24.418L16.1581 25.1514ZM16.4999 25.0781L16.6681 25.809C18.4837 25.3914 20.1818 24.5627 21.6296 23.3844L21.1562 22.8027L20.6828 22.221C19.4133 23.2541 17.9242 23.9809 16.3318 24.3472L16.4999 25.0781ZM21.1562 22.8027L21.6296 23.3844C23.1738 22.1276 24.3861 20.5113 25.1614 18.6779L24.4706 18.3857L23.7798 18.0936C23.0998 19.7018 22.0367 21.1191 20.6827 22.221L21.1562 22.8027ZM24.4706 18.3857L25.1614 18.6778C25.0061 19.0451 24.5921 19.1932 24.2512 19.0532L24.5361 18.3594L24.821 17.6656C24.4294 17.5048 23.9565 17.6758 23.7798 18.0936L24.4706 18.3857ZM24.5361 18.3594L24.244 19.0502C23.9055 18.907 23.7153 18.5068 23.8721 18.134L24.5634 18.4248L25.2547 18.7156C25.4329 18.2919 25.2174 17.8332 24.8282 17.6686L24.5361 18.3594ZM24.5634 18.4248L23.8726 18.1327C23.1864 19.7556 22.1122 21.1857 20.7452 22.2982L21.2187 22.8799L21.6921 23.4616C23.2487 22.1947 24.4723 20.5658 25.2542 18.7169L24.5634 18.4248ZM21.2187 22.8799L20.7453 22.2982C19.4638 23.3411 17.9613 24.0752 16.3542 24.4449L16.5224 25.1758L16.6905 25.9067C18.5213 25.4855 20.2327 24.6493 21.6921 23.4616L21.2187 22.8799ZM16.5224 25.1758L16.3665 24.4422L16.0218 24.5154L16.1777 25.249L16.3335 25.9826L16.6783 25.9094L16.5224 25.1758ZM16.1777 25.249L16.032 24.5133C14.4114 24.8342 12.7397 24.7789 11.1469 24.3526L10.953 25.0771L10.7592 25.8017C12.5738 26.2872 14.4777 26.3502 16.3233 25.9847L16.1777 25.249ZM10.953 25.0771L11.1583 24.3558L10.8184 24.2591L10.6132 24.9805L10.408 25.7018L10.7478 25.7985L10.953 25.0771ZM10.6132 24.9805L10.8292 24.2622C9.247 23.7865 7.79629 22.9545 6.58878 21.8316L6.07805 22.3809L5.56732 22.9301C6.94298 24.2093 8.5954 25.1569 10.3972 25.6987L10.6132 24.9805ZM6.07805 22.3809L6.59684 21.8392L6.34196 21.5951L5.82316 22.1367L5.30437 22.6783L5.55925 22.9225L6.07805 22.3809ZM5.82316 22.1367L6.35047 21.6034C5.17577 20.442 4.2844 19.0268 3.7436 17.4689L3.03508 17.7148L2.32655 17.9608C2.94249 19.7352 3.95773 21.3471 5.29586 22.6701L5.82316 22.1367ZM3.03508 17.7148L3.74762 17.4808L3.63727 17.1448L2.92473 17.3789L2.21218 17.613L2.32254 17.9489L3.03508 17.7148ZM2.92473 17.3789L3.64046 17.1548C3.11383 15.473 3.0065 13.6878 3.32904 11.9557L2.59172 11.8184L1.85439 11.6811C1.48692 13.6544 1.60928 15.6878 2.209 17.603L2.92473 17.3789ZM2.59172 11.8184L3.32667 11.9678L3.39698 11.6221L2.66203 11.4727L1.92708 11.3232L1.85677 11.6689L2.59172 11.8184ZM2.66203 11.4727L3.39481 11.6324C3.74614 10.0212 4.4631 8.51002 5.49129 7.21674L4.90422 6.75L4.31714 6.28326C3.14613 7.75619 2.32947 9.47742 1.92925 11.3129L2.66203 11.4727ZM4.90422 6.75L5.48394 7.22583L5.70758 6.95337L5.12785 6.47754L4.54812 6.00171L4.32449 6.27417L4.90422 6.75ZM5.12785 6.47754L5.70037 6.96202C6.76568 5.70311 8.10634 4.7036 9.62024 4.04285L9.32023 3.35547L9.02022 2.66809C7.29557 3.42082 5.76858 4.55933 4.55533 5.99306L5.12785 6.47754ZM9.32023 3.35547L9.46732 4.0909L9.48685 4.087L9.33976 3.35156L9.19268 2.61613L9.17315 2.62003L9.32023 3.35547ZM13.9364 2.44727V3.19727C15.3468 3.19727 16.7432 3.47462 18.0459 4.0142L18.3329 3.32129L18.6199 2.62838C17.135 2.0133 15.5434 1.69727 13.9364 1.69727V2.44727ZM18.3329 3.32129L18.0459 4.0142C19.3486 4.5538 20.5329 5.34556 21.5301 6.34283L22.0605 5.8125L22.5908 5.28217C21.4545 4.14584 20.1049 3.24348 18.6199 2.62838L18.3329 3.32129ZM22.0605 5.8125L21.5301 6.3428C22.5271 7.33994 23.3183 8.52352 23.8578 9.82608L24.5507 9.53906L25.2436 9.25205C24.6286 7.76734 23.727 6.41846 22.5908 5.2822L22.0605 5.8125ZM24.5507 9.53906L23.8578 9.82607C24.3974 11.1287 24.6747 12.5252 24.6747 13.9355L25.4247 13.9355L26.1747 13.9355C26.1747 12.3286 25.8587 10.737 25.2436 9.25205L24.5507 9.53906ZM25.4247 13.9355H24.6747C24.6747 14.0978 24.5434 14.2294 24.3806 14.2295L24.3808 14.9795L24.381 15.7295C25.3715 15.7292 26.1747 14.9267 26.1747 13.9355H25.4247ZM24.3808 14.9795V14.2295H13.9364V14.9795V15.7295H24.3808V14.9795ZM13.9364 14.9795V14.2295C13.7738 14.2295 13.6425 14.0981 13.6425 13.9355H12.8925H12.1425C12.1425 14.9266 12.9454 15.7295 13.9364 15.7295V14.9795ZM12.8925 13.9355H13.6425V3.49121H12.8925H12.1425V13.9355H12.8925ZM12.8925 3.49121L13.6425 3.49145C13.6425 3.41289 13.6737 3.33809 13.7285 3.28326L13.1982 2.75293L12.6678 2.2226C12.3311 2.55934 12.1426 3.01579 12.1425 3.49098L12.8925 3.49121ZM13.1982 2.75293L13.7284 3.28338C13.7835 3.22826 13.8583 3.19727 13.9364 3.19727V2.44727V1.69727C13.4608 1.69727 13.0045 1.88609 12.668 2.22248L13.1982 2.75293Z"
      fill="#474C5E"
    />
  </svg>
)

const ICON_2 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none">
    <path d="M3 19H24V23.5H7L4.5 26L3 19Z" fill="#D4DAE0" />
    <path
      d="M3.5 22.7501C3.5 21.6671 3.93021 20.6285 4.69598 19.8627C5.46175 19.097 6.50037 18.6667 7.58333 18.6667H23.3333C23.9777 18.6667 24.5 19.1891 24.5 19.8334"
      stroke="#474C5E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.69598 2.36273C5.46175 1.59696 6.50037 1.16675 7.58333 1.16675H23.3333C23.9777 1.16675 24.5 1.68908 24.5 2.33341V25.6667C24.5 26.3111 23.9777 26.8334 23.3333 26.8334H7.58333C6.50037 26.8334 5.46175 26.4032 4.69598 25.6374C3.93021 24.8717 3.5 23.833 3.5 22.7501V5.25008C3.5 4.16711 3.93021 3.1285 4.69598 2.36273Z"
      stroke="#474C5E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const ICON_3 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none">
    <g clip-path="url(#clip0_379_6800)">
      <path d="M10 18H1L1.5 26.5L10 27V18Z" fill="#D4DAE0" />
      <path d="M18 10V7.14286H11.4118L10 5V10H18Z" fill="#D4DAE0" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.3335 2.33341C9.3335 1.68908 9.85583 1.16675 10.5002 1.16675H17.5002C18.1445 1.16675 18.6668 1.68908 18.6668 2.33341V9.33341C18.6668 9.97775 18.1445 10.5001 17.5002 10.5001H10.5002C9.85583 10.5001 9.3335 9.97775 9.3335 9.33341V2.33341Z"
        stroke="#474C5E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5 18.6667C17.5 18.0223 18.0223 17.5 18.6667 17.5H25.6667C26.311 17.5 26.8333 18.0223 26.8333 18.6667V25.6667C26.8333 26.311 26.311 26.8333 25.6667 26.8333H18.6667C18.0223 26.8333 17.5 26.311 17.5 25.6667V18.6667Z"
        stroke="#474C5E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.16675 18.6667C1.16675 18.0223 1.68908 17.5 2.33341 17.5H9.33341C9.97775 17.5 10.5001 18.0223 10.5001 18.6667V25.6667C10.5001 26.311 9.97775 26.8333 9.33341 26.8333H2.33341C1.68908 26.8333 1.16675 26.311 1.16675 25.6667V18.6667Z"
        stroke="#474C5E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 17.5V15.1428C22 14.5117 21.5523 14 21 14H7C6.44772 14 6 14.5117 6 15.1428V17.5"
        stroke="#474C5E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 11V14"
        stroke="#474C5E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_379_6800">
        <rect width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

const ICON_4 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none">
    <path d="M25.5 8L14 1L8 4.5L20.5 11.5L25.5 8Z" fill="#D4DAE0" />
    <path
      d="M8 4.5L20 11.5"
      stroke="#474C5E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M2 20.5L2.5 12.5L5 18L14 22V27L2 20.5Z" fill="#D4DAE0" />
    <path
      d="M12.2524 1.63641C12.7839 1.33016 13.3865 1.16895 13.9999 1.16895C14.6134 1.16895 15.216 1.33017 15.7475 1.63645L15.7499 1.63786L23.9166 6.30451C24.4481 6.61141 24.8896 7.05267 25.1968 7.58406C25.5039 8.11544 25.666 8.71825 25.6666 9.33202V18.6677C25.666 19.2815 25.5039 19.8843 25.1968 20.4157C24.8896 20.9471 24.4481 21.3884 23.9166 21.6952L23.9121 21.6978L15.7499 26.3619L15.7478 26.3631C15.2163 26.6695 14.6135 26.8308 13.9999 26.8308C13.3864 26.8308 12.7836 26.6695 12.2521 26.3632L12.2499 26.3619L4.08776 21.6978L4.08325 21.6952C3.55171 21.3884 3.11022 20.9471 2.80306 20.4157C2.4959 19.8843 2.33388 19.2815 2.33325 18.6677V9.33202C2.33388 8.71825 2.4959 8.11544 2.80306 7.58406C3.11022 7.05267 3.55171 6.61141 4.08325 6.30452L4.08775 6.30193L12.2524 1.63641Z"
      stroke="#474C5E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.4997 8.70765L14.5808 15.0116C14.2211 15.218 13.7788 15.218 13.4191 15.0116L2.5 8.70752"
      stroke="#474C5E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 15.5V26.6667"
      stroke="#474C5E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const CompetitiveSection: FCC<{ className?: string }> = ({ className }) => {
  const { t } = useTranslation()

  const SECTIONS = [
    {
      contentTitle: t('solutions:competitive:section_1_content_title'),
      iconType: ICON_1,
      contentDescription: t(
        'solutions:competitive:section_1_content_description'
      ),
      contentImage: '/img/feature/lp/new/solutionCompetitive01.png',
      contentLink: '#'
    },
    {
      contentTitle: t('solutions:competitive:section_2_content_title'),
      iconType: ICON_2,
      contentDescription: t(
        'solutions:competitive:section_2_content_description'
      ),
      contentImage: '/img/feature/lp/new/solutionCompetitive02.png',
      contentLink: '#'
    },
    {
      contentTitle: t('solutions:competitive:section_3_content_title'),
      iconType: ICON_3,
      contentDescription: t(
        'solutions:competitive:section_3_content_description'
      ),
      contentImage: '/img/feature/lp/new/solutionCompetitive03.png',
      contentLink: '#'
    },
    {
      contentTitle: t('solutions:competitive:section_4_content_title'),
      iconType: ICON_4,
      contentDescription: t(
        'solutions:competitive:section_4_content_description'
      ),
      contentImage: '/img/feature/lp/new/solutionCompetitive04.png',
      contentLink: '#'
    }
  ]

  return (
    <SectionContainer
      title="solutions:title02"
      // tagLabel="solutions:tag"
      // tagColor="bg-purple-100 text-purple-800"
      className="pb-5 mt-[64px] mb-0 desktop:mt-[140px] desktop:mb-0">
      <div className="relative">
        <div className="h-5 border-gray-100 border-r absolute -top-5 left-0 border-dashed" />
        <div className="w-5 border-gray-100 border-t absolute top-0 -left-5 border-dashed" />
        <div className="absolute -top-1.5 -left-1.5 z-10">{PLUS}</div>

        <div className="h-5 border-gray-100 border-r absolute -top-5 right-0 border-dashed" />
        <div className="w-5 border-gray-100 border-t absolute top-0 -right-5 border-dashed" />
        <div className="absolute -top-1.5 -right-1.5 z-10">{PLUS}</div>

        <div className="h-5 border-gray-100 border-r absolute -bottom-5 left-0 border-dashed" />
        <div className="w-5 border-gray-100 border-t absolute bottom-0 -left-5 border-dashed" />
        <div className="absolute -bottom-1.5 -left-1.5 z-10">{PLUS}</div>

        <div className="h-5 border-gray-100 border-r absolute -bottom-5 right-0 border-dashed" />
        <div className="w-5 border-gray-100 border-t absolute bottom-0 -right-5 border-dashed" />
        <div className="absolute -bottom-1.5 -right-1.5 z-10">{PLUS}</div>

        <div className="flex flex-col tablet:flex-row tablet:flex-wrap align-middle w-full justify-center mt-6 border-gray-100 border border-r-0 border-b-0">
          {SECTIONS.map((item, index) => (
            <div
              key={index}
              className="flex-1 border-gray-100 border-r border-b min-w-[50%] relative p-8">
              <div className="absolute right-[18px] top-[18px]">
                {item.iconType}
              </div>
              <TypographyText className="text-[23px] font-medium text-gray-900">
                {item.contentTitle}
              </TypographyText>
              <TypographyText className="text-base font-normal text-gray-700 mt-1">
                {item.contentDescription}
              </TypographyText>
              <div className="mt-6">
                <Image
                  src={item.contentImage}
                  width={544}
                  height={0}
                  alt={`${item.contentImage}-image`}
                  className="h-auto"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </SectionContainer>
  )
}

export default CompetitiveSection
